import { useMutation } from '@apollo/client';
import { RESET_PASSWORD } from '../../apollo/mutations/user';

const useResetPassword = () => {
  const [resetPasswordMutation, { loading }] = useMutation(RESET_PASSWORD);

  const resetPassword = async (variables) => {
    try {
      const { data } = await resetPasswordMutation({ variables });

      if (!data?.resetPassword) {
        throw new Error('Reset password failed.');
      }

      return data.resetPassword;
    } catch (error) {
      throw error;
    }
  };

  return { resetPassword, loading };
};

export default useResetPassword;